export default __webpack_public_path__ + "static/media/incapacidad-para-moverse.a7d1066f.png";